import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { CancelPanel, Loading, ReceiptMor, ReceiptNotMor } from '../../components';
import { useTripStoreUpdater } from '../../hooks';
import { fetchReceipt } from '../../store/actions';
import { ReceiptState } from '../../types/receipt.store.type';
import { StoreState } from '../../types/store.type';
import { SharedUtils, TranslationUtils } from '../../utils';
import { LanguageCodes } from '../../types/preference.type';
import { Guests, Reservation, Stay } from 'guest-data-types-ts-lib';

export const Receipt: React.FC = () => {
    useTripStoreUpdater(true);
    const dispatch = useDispatch();
    const { trip, user } = useSelector((store: StoreState) => store);
    const { reservation, required_actions, unit, guests, stay } = trip;
    const receiptState = useSelector((store: { receipt: ReceiptState }) => store.receipt);
    const { receipt, error } = receiptState;

    useEffect(() => {
        if (reservation && reservation.vacasa_is_merchant_of_record) {
            dispatch(fetchReceipt(reservation.id));
        }
    }, [reservation?.id, user.currency]);

    if (trip.isLoading || receiptState.isLoading) {
        return <Loading />;
    }

    const title = TranslationUtils.get('receipt_title');

    const renderReceipt = (): any => {
        if (!!error) {
            return <ReceiptNotMor />;
        }

        if (reservation && !reservation.vacasa_is_merchant_of_record) {
            return <ReceiptNotMor />;
        } else if (required_actions && receipt && unit) {
            const locale = SharedUtils.getUserLanguageCode(user);
            return (
                <ReceiptMor
                    reservation={reservation as Reservation}
                    guests={guests as Guests}
                    stay={stay as Stay}
                    requiredActions={required_actions}
                    receipt={receipt}
                    unit={unit}
                    locale={locale as LanguageCodes}
                />
            );
        }
        return null;
    };

    return (
        <Container>
            <h1 tabIndex={0} className="heading-large page-title">
                {title}
            </h1>
            <div className="row">{renderReceipt()}</div>
            <br />
            <div className="mb-4" />
            <CancelPanel />
        </Container>
    );
};
